require("./bootstrap");
require("./main-navigation");
require("./consent");
require("./swiper");

// Templates
require("./templates/product-category");
require("./templates/common-part-cart");